import React from 'react';
import useFlowInputComponent from '../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../types/FlowsTypes';
import RichTextInput from './RichTextInput';

interface Props {
  question: FlowsQuestion;
}

const RichTextInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { name, value, onBlur },
    error,
    prefilled,
  } = useFlowInputComponent({ question });
  const [inputValue, setInputValue] = React.useState<string>(value || '');

  return (
    <RichTextInput
      onChange={setInputValue}
      prefilled={prefilled}
      onBlurUpdate={(e: string) => onBlur({ name, value: e })}
      value={inputValue}
      error={error}
      controls={question.rules.options?.rich_text_options || undefined}
      isDisabled={question.rules.is_disabled}
    />
  );
};

export default RichTextInputComponent;
